const speciaOperandValue = {
    null:'Null'
}

export default speciaOperandValue;
